import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('UI error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          fontFamily: '-apple-system, system-ui, sans-serif',
          padding: 20,
          color: '#fff',
          background: '#0f172a',
          minHeight: '100vh'
        }}>
          <h2 style={{ margin: '0 0 8px 0' }}>JS error</h2>
          <div style={{ opacity: 0.85, whiteSpace: 'pre-wrap' }}>{String(this.state.error)}</div>
          <pre style={{ marginTop: 12, fontSize: 12, opacity: 0.7, whiteSpace: 'pre-wrap' }}>
            {this.state.info?.componentStack}
          </pre>
          <div style={{ marginTop: 12, fontSize: 12, opacity: 0.6 }}>WORKIFYPL v7.32</div>
        </div>
      );
    }

    return this.props.children;
  }
}
